export class Infobox {
	#collapsedHeight = 100;
	constructor(box) {
		this.box = box;
		this.content = this.box.querySelector(".box__content");
		this.overlay = this.box.querySelector(".box__show-more");
		this.trigger = this.overlay.querySelector(".box__show-more-trigger");
		this.closeTrigger = this.overlay.querySelector(
			".box__collapse-trigger"
		);
		this.links = this.content.querySelectorAll("a");
		this.state = false;
		this.toggle = this.toggle.bind(this);
		this.resize = this.resize.bind(this);
		this.init();
	}

	init() {
		this.box.setAttribute("tabindex", -1);
		this.content.style.overflow = "hidden";
		this.content.style.transition = "max-height .5s, padding .5s";
		this.trigger.addEventListener("click", this.toggle);
		this.closeTrigger.addEventListener("click", this.toggle);
		window.addEventListener("resize", this.resize);

		this.collapse();
	}

	resize() {
		if (this.state) this.expandHeight();
	}

	aria() {
		this.content.setAttribute("data-expanded", this.state);
		this.trigger.setAttribute("aria-expanded", this.state);
		this.closeTrigger.setAttribute("aria-expanded", this.state);
	}

	expandHeight() {
		const height = this.content.scrollHeight;
		const overlayHeight = this.overlay.scrollHeight;
		this.content.style.maxHeight = `${height + overlayHeight}px`;
	}

	expand() {
		this.state = true;
		this.aria();
		this.expandHeight();
		this.links.forEach((element) => element.removeAttribute("tabindex"));
		this.trigger.remove();
		this.box.focus();
		this.overlay.appendChild(this.closeTrigger);
	}

	collapse() {
		this.state = false;
		this.aria();
		this.content.style.maxHeight = `${this.#collapsedHeight}px`;
		this.links.forEach((element) => element.setAttribute("tabindex", -1));
		this.closeTrigger.remove();
		this.overlay.appendChild(this.trigger);
	}

	toggle(e) {
		e.preventDefault();
		if (this.state) {
			this.collapse();
		} else {
			this.expand();
		}
	}
}
